import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NetworkHeadingComponent } from '../network-heading/network-heading.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
@AutoUnsubscribe()
@Component({
    selector: 'setup-controller',
    templateUrl: './family-setup.component.html',
    imports:[
      CommonModule,
      NetworkHeadingComponent
    ]
})
export class SetupComponent implements OnInit, OnDestroy {
  @Output() optionValueEmitter = new EventEmitter();
  @Output() relationshipListEmitter = new EventEmitter();
  @Output() moveToNextStepEmitter = new EventEmitter<void>();
  @Input() currentUser;
  @Input() screenWidth;
  @Input() text = '';
  @Input() subText;
  @Input() id;
  @Input() relationshipType;
  @Input() currentType;
  @ViewChild(NetworkHeadingComponent) networkHeadingComponent;

  options = [{ value: 'Yes' }, { value: 'No' }];
  constructor() {}

  ngOnInit(): void {}
  ngOnDestroy(): void {}
  selectOption(value) {
    this.optionValueEmitter.emit(value);
  }
  handlerRelationshipList(value) {
    this.relationshipListEmitter.emit(value);
  }
}
